import React, { useState } from "react";
import ModalComponent from "../../../components/Tenant/ModalComponent/ModalComponent";
import { useBulkUploadSchemeRewardsMutation } from "../../../features/tenant/scheme/schemeApi";
import { toast } from "react-hot-toast";
import Papa from "papaparse";
import {
  HiOutlineDocumentText,
  HiOutlineCheckCircle,
  HiOutlineExclamationCircle,
  HiOutlineCloudUpload,
  HiOutlineDownload,
} from "react-icons/hi";
import { downloadSampleCSV } from "../../../utils/downloadSampleCsv";

const BulkRewardModal = ({ show, setShow, schemeData }) => {
  const [file, setFile] = useState(null);
  const [uploadResult, setUploadResult] = useState(null);
  const [bulkUpload, { isLoading }] = useBulkUploadSchemeRewardsMutation();

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setUploadResult(null);
  };

  const handleUpload = async () => {
    if (!file) {
      toast.error("Please select a file first");
      return;
    }

    try {
      const response = await bulkUpload({
        token: sessionStorage.getItem("access_token"),
        tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
        file: file,
        scheme_id: schemeData?.id,
      }).unwrap();

      console.log(response);

      if (response.status) {
        toast.success(response.message || "Upload successful");
        setUploadResult(response.body);
        // setTimeout(() => {
        //   setShow(false)
        //   setFile(null)
        //   setUploadResult(null)
        // }, 2000);
      } else {
        toast.error(response.message || "Upload failed");
      }
    } catch (error) {
      console.error("Upload error:", error);
      toast.error(error?.data?.message || "Something went wrong during upload");
    }
  };

  const resetModal = () => {
    setFile(null);
    setUploadResult(null);
    setShow(false);
  };

  const handleDownloadCSV = () => {
    if (!uploadResult || !uploadResult.details) return;

    const csvData = uploadResult.details.map((detail) => ({
      Row: detail.row - 1,
      Mobile: detail.mobile,
      Status: detail.status.charAt(0).toUpperCase() + detail.status.slice(1),
      Details:
        detail.status === "success"
          ? `Entry ID: ${detail.entryId}`
          : detail.reason,
    }));

    const csv = Papa.unparse(csvData);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute(
      "download",
      `bulk_reward_summary_${schemeData?.id}_${new Date().getTime()}.csv`,
    );
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <ModalComponent
      show={show}
      setShow={setShow}
      size="lg"
      title={`Bulk Reward - ${schemeData?.name}`}
    >
      <div className="p-4">
        {!uploadResult ? (
          <div className="space-y-6">
            {/* <div className="bg-blue-50 border-l-4 border-blue-400 p-4 rounded-r-md">
              <div className="flex">
                <div className="flex-shrink-0">
                  <HiOutlineDocumentText className="h-5 w-5 text-blue-400" />
                </div>
                <div className="ml-3">
                  <h3 className="text-sm font-medium text-blue-800">
                    File Format Requirements
                  </h3>
                  <div className="mt-2 text-sm text-blue-700">
                    <ul className="list-disc pl-5 space-y-1">
                      <li>Supported formats: .csv, .xls, .xlsx</li>
                      <li>
                        Required Columns: <strong>mobile</strong>,{" "}
                        <strong>scheme_id</strong>, <strong>value</strong>
                      </li>
                      <li>
                        Optional Column: <strong>remarks</strong>
                      </li>
                      <li>
                        Selected Scheme ID:{" "}
                        <span className="font-bold underline">
                          {schemeData?.id}
                        </span>{" "}
                        (Ensure this ID is used in the file)
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div> */}

            {/* <div>
              <button
                type="submit"
                className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center "
                onClick={() =>
                  downloadSampleCSV([
                    {
                      name: "mobile",
                    },
                    {
                      name: "scheme_id",
                    },
                    {
                      name: "value",
                    },
                    {
                      name: "remarks",
                    },
                  ])
                }
              >
                Sample Csv Download
              </button>
            </div> */}

            <div className="bg-blue-50 border-l-4 border-blue-400 p-4 rounded-r-md">
              <div className="flex flex-col">
                {/* Icon + Title + List */}
                <div className="flex">
                  <div className="flex-shrink-0">
                    <HiOutlineDocumentText className="h-5 w-5 text-blue-400" />
                  </div>
                  <div className="ml-3 w-full">
                    <h3 className="text-sm font-medium text-blue-800">
                      File Format Requirements
                    </h3>
                    <div className="mt-2 text-sm text-blue-700">
                      <ul className="list-disc pl-3 space-y-1">
                        <li className="whitespace-nowrap">
                          Supported formats: .csv, .xls, .xlsx
                        </li>
                        <li className="whitespace-nowrap">
                          Required Base Columns: <strong>mobile</strong>,{" "}
                          <strong>scheme_id</strong>
                        </li>
                        <li>
                          Conditional Code Column (Exactly ONE required):{" "}
                          <strong>batch_running_code</strong>,{" "}
                          <strong>unique_code</strong>, or{" "}
                          <strong>scratch_code</strong>
                        </li>
                        <li className="whitespace-nowrap">
                          Optional Column: <strong>remarks</strong>
                        </li>
                        <li className="whitespace-nowrap">
                          Selected Scheme ID:{" "}
                          <span className="font-bold underline">
                            {schemeData?.id}
                          </span>{" "}
                          (Ensure this ID is used in the file)
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                {/* Button centered at bottom */}
                <div className="flex justify-center mt-3">
                  <button
                    type="button"
                    className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-xs px-4 py-1.5"
                    onClick={() =>
                      downloadSampleCSV([
                        { name: "mobile" },
                        { name: "scheme_id" },
                        { name: "value" },
                        { name: "remarks" },
                      ])
                    }
                  >
                    Sample Csv Download
                  </button>
                </div>
              </div>
            </div>

            <div className="flex flex-col items-center justify-center border-2 border-dashed border-gray-300 rounded-xl p-10 bg-gray-50 hover:bg-gray-100 transition-colors duration-200 cursor-pointer relative">
              <input
                type="file"
                className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                onChange={handleFileChange}
                accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              />
              <HiOutlineCloudUpload className="w-12 h-12 text-gray-400 mb-2" />
              <p className="text-gray-600 font-medium">
                {file ? file.name : "Click or drag to upload file"}
              </p>
              <p className="text-gray-400 text-sm mt-1">
                CSV, XLS, XLSX strictly allowed
              </p>
            </div>

            <div className="flex justify-end space-x-3">
              <button
                onClick={() => setShow(false)}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none"
              >
                Cancel
              </button>
              <button
                onClick={handleUpload}
                disabled={isLoading || !file}
                className={`flex items-center px-6 py-2 text-sm font-medium text-white rounded-md focus:outline-none shadow-sm ${
                  isLoading || !file
                    ? "bg-blue-400 cursor-not-allowed"
                    : "bg-blue-600 hover:bg-blue-700"
                }`}
              >
                {isLoading ? (
                  <>
                    <svg
                      className="animate-spin -ml-1 mr-3 h-4 w-4 text-white"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    Uploading...
                  </>
                ) : (
                  "Start Upload"
                )}
              </button>
            </div>
          </div>
        ) : (
          <div className="space-y-6">
            <div className="grid grid-cols-3 gap-4">
              <div className="bg-gray-50 p-4 rounded-lg text-center border border-gray-100">
                <span className="block text-2xl font-bold text-gray-900">
                  {uploadResult.total}
                </span>
                <span className="text-xs text-gray-500 uppercase tracking-wider">
                  Total Rows
                </span>
              </div>
              <div className="bg-green-50 p-4 rounded-lg text-center border border-green-100">
                <span className="block text-2xl font-bold text-green-600">
                  {uploadResult.success}
                </span>
                <span className="text-xs text-green-500 uppercase tracking-wider">
                  Success
                </span>
              </div>
              <div className="bg-red-50 p-4 rounded-lg text-center border border-red-100">
                <span className="block text-2xl font-bold text-red-600">
                  {uploadResult.failed}
                </span>
                <span className="text-xs text-red-500 uppercase tracking-wider">
                  Failed
                </span>
              </div>
            </div>

            <div className="border border-gray-200 rounded-lg overflow-hidden">
              <div className="bg-gray-50 px-4 py-2 border-b border-gray-200">
                <h4 className="text-sm font-semibold text-gray-700">
                  Detailed Results
                </h4>
              </div>
              <div className="max-h-64 overflow-y-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50 sticky top-0">
                    <tr>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">
                        Row
                      </th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">
                        Mobile
                      </th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">
                        Status
                      </th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">
                        Details
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {uploadResult.details.map((detail, idx) => (
                      <tr
                        key={idx}
                        className={
                          detail.status === "failed" ? "bg-red-50/30" : ""
                        }
                      >
                        <td className="px-4 py-2 text-sm text-gray-600">
                          {detail.row - 1}
                        </td>
                        <td className="px-4 py-2 text-sm text-gray-600">
                          {detail.mobile}
                        </td>
                        <td className="px-4 py-2 text-sm">
                          {detail.status === "success" ? (
                            <span className="inline-flex items-center text-green-700">
                              <HiOutlineCheckCircle className="mr-1" /> Success
                            </span>
                          ) : (
                            <span className="inline-flex items-center text-red-700">
                              <HiOutlineExclamationCircle className="mr-1" />{" "}
                              Failed
                            </span>
                          )}
                        </td>
                        <td className="px-4 py-2 text-sm text-gray-500">
                          {detail.status === "success"
                            ? `Entry ID: ${detail.entryId}`
                            : detail.reason}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="flex justify-end space-x-3">
              <button
                onClick={handleDownloadCSV}
                className="flex items-center px-4 py-2 text-sm font-medium text-blue-600 bg-blue-50 border border-blue-200 rounded-md hover:bg-blue-100 focus:outline-none transition-colors"
              >
                <HiOutlineDownload className="mr-2 h-4 w-4" />
                Download Results (CSV)
              </button>
              <button
                onClick={resetModal}
                className="px-6 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none shadow-sm"
              >
                Close Summary
              </button>
            </div>
          </div>
        )}
      </div>
    </ModalComponent>
  );
};

export default BulkRewardModal;
